import { render, staticRenderFns } from "./Cherchables.vue?vue&type=template&id=fdf6f48a&"
import script from "./Cherchables.vue?vue&type=script&lang=js&"
export * from "./Cherchables.vue?vue&type=script&lang=js&"
import style0 from "./Cherchables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports